import { Component } from '@angular/core';
import { AppTypeEnum } from '../../../model/appType';
import { Subject, takeUntil } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { OnlineService } from '../../../services/online.service';
import { ThemeService } from '../../../services/theme.service';
import { UserService } from '../../../services/user.service';
import { TranslateService } from '@ngx-translate/core';
import { SnackBarService } from '../../../services/snackBar.service';
import { SpinnerService } from '../../../services/spinner.service';
import { GlobalStateService } from '../../../services/globalState.service';
import { RoleUser } from '../../../model/roleUser';
import { User } from 'src/app/model/user';
import { DrawerService } from '../../../services/drawer.service';

@Component({
  selector: 'app-home-balances',
  templateUrl: './home-balances.component.html',
  styleUrl: './home-balances.component.scss',
  standalone: false
})
export class HomeBalancesComponent {
  timestampt: string;

  user = new User();

  selectedGroup: number;
  selectedApp: number;
  roles: RoleUser[];

  selectedComponent: string;
  airState: any;
  roouterPath: boolean;

  private destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private onlineService: OnlineService,
    private themeService: ThemeService,
    private userService: UserService,
    private translate: TranslateService,
    public snackBarService: SnackBarService,
    private spinnerService: SpinnerService,
    private drawerService: DrawerService,
    private globalStateService: GlobalStateService) {
      const currentProfile = userService.currentProfile;

      this.roles = currentProfile.profiles;
      this.selectedGroup = currentProfile.profiles
        .find(p => p.idGroup === currentProfile.idActiveProfile)?.idGroup;
    }

  ngOnInit(): void {
    localStorage.removeItem('filter');
    localStorage.removeItem('filter-equipment');
    localStorage.removeItem('customFields');
    this.timestampt = environment.timeStamp;

    this.user = this.userService.currentProfile;
    this.roouterPath = false;

    this.globalStateService.calibratesState$.subscribe((newState) => {
    });
    this.drawerService.close();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  goToPage(page: string): void {
    this.roouterPath = true;
    void this.router.navigateByUrl(page);
  }

  downloadData(): void {
    this.spinnerService.show();

    this.onlineService.downloadCacheableData().pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.snackBarService.sendSuccess(this.translate.instant('home.form.downloadDataOffline.ok') as string);

      this.spinnerService.hide();
    }, () => {
      this.snackBarService.sendError(this.translate.instant('home.form.downloadDataOffline.error') as string);

      this.spinnerService.hide();
    });
  }

  showExternalEquipments(): boolean {
    const currentUser = this.userService.currentProfile;

    if (currentUser == null) {
      return false;
    }

    return currentUser.showExternalEquipments;
  }

  showCharacterization(): boolean {
    const currentUser = this.userService.currentProfile;

    if (currentUser === null || currentUser === undefined) {
      return false;
    }

    return currentUser.showCharacterization;
  }

  getLogo(): string {
    return 'assets/img/qloud_calibrates.png';
  }

  getText(): string {
    return 'landing.main.balances';
  }

  getThemeIconPath(): string {
    return 'assets/icons/calibrates/';
  }

  newInternalEquipment(): void {
    void this.router.navigateByUrl('balances/internalEquipment?id=0');
  }

  newExternalEquipment(): void {
    void this.router.navigateByUrl('balances/externalEquipment?id=0');
  }

  newCalibration(): void {
    void this.router.navigateByUrl('balances/calibration?id=0');
  }

  navigateToCalibratesOptions(url: string): void {
    this.roouterPath = true;
    const newState = { selectedOption: 'balances-'+url };
    this.globalStateService.updateTabState('main-tab', newState);
    void this.router.navigate(['balances',url]);
  }

  getTheme(): string {
    return this.themeService.getThemeHome(AppTypeEnum.CALIBRATES);
  }
}
